"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_toastify_1 = require("react-toastify");
require("./notification.scss");
const info_icon_svg_1 = __importDefault(require("../../assets/images/icons/info-icon.svg"));
const verified_icon_svg_1 = __importDefault(require("../../assets/images/icons/verified-icon.svg"));
const pending_icon_svg_1 = __importDefault(require("../../assets/images/icons/pending-icon.svg"));
const not_verified_icon_svg_1 = __importDefault(require("../../assets/images/icons/not-verified-icon.svg"));
const react_1 = __importDefault(require("react"));
function Notification(props) {
    return (0, react_toastify_1.toast)(react_1.default.createElement("div", { className: "flex-row" },
        react_1.default.createElement("img", { className: "toast-icon", src: props.type === "info"
                ? info_icon_svg_1.default
                : props.type === "success"
                    ? verified_icon_svg_1.default
                    : props.type === "warning"
                        ? pending_icon_svg_1.default
                        : not_verified_icon_svg_1.default, alt: "" }),
        react_1.default.createElement("span", { className: "s7-5" }, props.text)), {
        type: props.type,
        hideProgressBar: true,
        autoClose: 5000,
    });
}
exports.default = Notification;
